<template>
    <div class="col-12 text-center pt-4">
        <div class="spinner-grow" role="status">
            <span class="sr-only">
                Carregando....
            </span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SpinnerGrowLoading',
    data() {
        return {
            
        }
    },
    methods: {
    }
}
</script>

<style scopedß>

</style>


// WEBPACK FOOTER //
// src/components/molecules/SpinnerGrowLoading.vue